import { Modal } from "@/components/ui/Modal.tsx";
import {useEffect, useState} from "react";
import { Button } from "@/components/ui/Button.tsx";
import {Flex, FlexAlignCenter} from "@/components/ui/FlexBox.ts";
import { Input } from "@/components/ui/Input.tsx";
import { PlusLogo } from "@/assets/Logos.tsx";
import {styled} from "styled-components";
import {CloseIcon} from "@/assets/Icons.tsx";
import {uuid} from "@/utils/uuid.ts";

const DeleteItem = styled.button`
    border: none;
    border-radius: 50%;
    width: 23px;
    display: flex;
    height: 23px;
    background: rgba(217, 217, 217, 1);
    justify-content: center;
    align-items: center;
    margin-left: 8px;
    cursor: pointer;
    
    svg {
        width: 8px;
        height: 8px;
    }
`

const HeadersValue = styled.div`
    width: 310px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

interface IAddHeadersModal {
    onChange: (value: any) => void;
    label: string;
    modalTitle: string;
    initialValue: {key: string, value: string}[]
    disabled?: boolean
}

export const AddRequestParamsModal = ({ onChange, label, modalTitle, initialValue, disabled }: IAddHeadersModal) => {
    const [isOpen, setIsOpen] = useState(false);
    const [params, setParams] = useState<{key: string, value: string, id: string}[]>([]);
    const [key, setKey] = useState('');
    const [value, setValue] = useState('');

    const addValue = () => {
        setParams((prevState) => [...prevState, {key, value, id: uuid()}])
        setKey('')
        setValue('')
    }

    const removeItem = (id: string) => {
        setParams((prevState) => prevState.filter(i => i.id !== id))
    }

    const closeAndSave = () => {
        onChange(params);
        setIsOpen(false)
    }

    useEffect(() => {
        if(isOpen && initialValue){
            setParams(initialValue.map(i => ({
                ...i,
                id: uuid()
            })))
        }
    }, [isOpen]);

    return (
        <div>
            <Button
                onClick={() => setIsOpen(true)}
                disabled={disabled}
                style={{ minWidth: 'max-content' }}
                variant="link"
            >
                {label}
            </Button>
            <Modal isOpen={isOpen} title={modalTitle} onClose={() => setIsOpen(false)}>
                <Flex>
                    <div style={{ marginRight: '5px' }}>
                        <Input
                            value={key}
                            onChange={(e) => setKey(e.target.value)}
                            placeholder='key'
                            style={{ width: '220px' }}
                        />
                    </div>
                    <Input
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        placeholder='value'
                        style={{ width: '220px' }}
                    />
                    <Button
                        onClick={addValue}
                        disabled={!key || !value}
                        style={{ marginLeft: '12px', width: '55px', padding: '0' }}
                        variant="primary"
                    >
                        <PlusLogo />
                    </Button>
                </Flex>
                <div style={{ marginTop: params.length ? '24px' : 0, paddingLeft: '5px' }}>
                    {params.map((i, index) => (
                        <FlexAlignCenter style={{ marginTop: index === 0 ? 0 : '17px' }} key={i.id}>
                            <HeadersValue>
                                {i.key}: {i.value}
                            </HeadersValue>
                            <DeleteItem onClick={() => removeItem(i.id)}>
                                <CloseIcon />
                            </DeleteItem>
                        </FlexAlignCenter>
                    ))}
                </div>
                <Flex style={{ justifyContent: 'end', marginTop: '20px' }}>
                    <Button onClick={closeAndSave} variant="primary">
                        Сохранить
                    </Button>
                </Flex>
            </Modal>
        </div>
    )
}
